define('exq-admin/tests/helpers/resolver', ['exports', 'ember/resolver', 'exq-admin/config/environment'], function (exports, _emberResolver, _exqAdminConfigEnvironment) {

  var resolver = _emberResolver['default'].create();

  resolver.namespace = {
    modulePrefix: _exqAdminConfigEnvironment['default'].modulePrefix,
    podModulePrefix: _exqAdminConfigEnvironment['default'].podModulePrefix
  };

  exports['default'] = resolver;
});